import React, { Component, Fragment } from 'react';
import { Alert, Spinner, toaster } from 'evergreen-ui';
import Validate from 'validator';
import api from '../../services/api';
import file from '../../services/briefing/file';
import Str from '../../services/str';
import { InfoBar } from '../InfoBar';
import { Box } from '../utilities/styledComponents/Box';
import { StyledForm } from '../utilities/styledComponents/StyledForm';

export default class FormCampaignPosting extends Component {
	constructor(props) {
		super(props);

		this.state = {
			briefing: null,
			customer: null,
			demand: null,
			status: null,
			adsTemplates: null,
			wmAdTypeOptions: null,
			wmAdOrderOptions: null,
			wmAdQuantityMin: 1,
			wmAdQuantityMax: 1,
			selectTemplates: [],
			formValues: {
				wm_ad_quantity: 0,
				wm_ad_type: '',
				wm_ad_order: '',
				demand_id: 0,
				ads_template_ids: [],
			},
			messageErrors: this.getMessageErrorsDefault(),
		};
	}

	componentDidMount() {
		const { demandId } = this.props;
		this.getDemandDetails(demandId);
	}

	getMessageErrorsDefault = () => ({
		wm_ad_quantity: '',
		wm_ad_type: '',
		wm_ad_order: '',
		demand_id: '',
		ads_template_ids: '',
	});

	getDemandDetails = demandId => api.get(`/demands/${demandId}/details`)
		.then(result => this.setState({
			briefing: result.data.data.relationships.briefing,
			customer: result.data.data.relationships.customer,
			demand: result.data.data.id,
			status: result.data.data.relationships.status,
			adsTemplates: this.groupTemplatesByChannel(result.data.data.relationships.ads_templates),
			wmAdTypeOptions: result.data.meta.wm_ad_type_options,
			wmAdOrderOptions: result.data.meta.wm_ad_order,
			wmAdQuantityMin: result.data.meta.wm_ad_quantity_min,
			wmAdQuantityMax: result.data.meta.wm_ad_quantity_max,
		}, () => {
			const { formValues, demand } = this.state;
			formValues.demand_id = demand;
			this.setState({ formValues });
		}))
		.catch(e => toaster.danger(
			`Falha ao carregar detalhes: ${e.message}`,
		));

	getDataGreyBar = () => {
		const {
			briefing, customer, status,
		} = this.state;

		return [
			{ title: 'CNPJ:', value: customer.document_number },
			{ title: 'Cliente:', value: customer.trading_name },
			{ title: 'ID Pré Venda:', value: briefing.pre_sale_id },
			{ title: 'Canais:', value: briefing.channels },
			{ title: 'Status:', value: status.title },
		];
	};

	getDataWhiteBar = () => {
		const { briefing } = this.state;
		const defaultValue = '--';
		return [
			{ title: 'Valor da venda:', value: briefing.budgets.total || defaultValue },
			{ title: 'Valor Instagram:', value: briefing.budgets.instagram || defaultValue },
			{ title: 'Valor Facebook:', value: briefing.budgets.facebook || defaultValue },
			{ title: 'Valor FEE:', value: briefing.budgets.fee || defaultValue },
			{ title: 'Valor Google:', value: briefing.budgets.google || defaultValue },
			{ title: 'Objetivo:', value: briefing.objective },
		];
	};

	getFormValidationRules = () => {
		const { wmAdQuantityMin, wmAdQuantityMax } = this.state;

		return {
			wm_ad_quantity: ['required', `max:${wmAdQuantityMax}`, `min:${wmAdQuantityMin}`],
			wm_ad_type: ['required'],
			wm_ad_order: ['required'],
			demand_id: ['notZero'],
			ads_template_ids: ['countNotZero'],
		};
	};

	groupTemplatesByChannel = (adsTemplates) => {
		const result = [];

		adsTemplates.forEach((template) => {
			const title = template.relationships.template_type.title;
			const channel = Str.toSnake(template.attributes.title);
			if (!result.find(element => element.title === title)) {
				result.push({ title, channel, templates: [] });
			}
			const { templates } = result.find(element => element.title === title);
			templates.push(template);
		});
		return result;
	};

	getTemplateOptions = (templates) => {
		const options = [
			{ value: 0, label: 'Escolha um template.' },
		];

		templates.forEach(template => options.push(
			{ value: template.id, label: template.attributes.title },
			));
		return options;
	};

	renderOption = option => (
		<option
			key={`opt_${Str.toSlug(option.label)}`}
			value={option.value}
		>
			{option.label}
		</option>
	);

	renderOptions = options => options.map(option => this.renderOption(option));

	handleForm = (e) => {
		const { name, value } = e.target;
		const { formValues, messageErrors } = this.state;
		formValues[name] = parseInt(value, 0) || value; 
		messageErrors[name] = '';
		this.setState({ formValues, messageErrors });
	};

	handleSelectTemplate = (e) => {
		const { name, value } = e.target;
		const { selectTemplates, formValues, messageErrors } = this.state;
		selectTemplates[name] = parseInt(value, 0); 
		formValues.ads_template_ids = Object.values(selectTemplates)
			.filter(item => item > 0);
		messageErrors.ads_template_ids = '';
		this.setState({ selectTemplates, formValues, messageErrors });
	};

	validateForm = () => {
		const {
			formValues,
			adsTemplates,
		} = this.state;

		const messageErrors = this.getMessageErrorsDefault();

		const rules = this.getFormValidationRules();
		Object.keys(rules).forEach((key) => {
			rules[key].forEach((item) => {
				const [validator, param] = item.split(':');

				switch (validator) {
					case 'required': messageErrors[key] = !formValues[key]
						? '* Este campo é obrigatório' : messageErrors[key];
					break;
					case 'notZero': messageErrors[key] = formValues[key] === 0
						? '* Este campo deve ter um valor acima de zero.' : messageErrors[key]; 
					break;
					case 'countNotZero': messageErrors[key] = formValues[key].length === 0 
						? '* Escolha os templates de anúncio.' : messageErrors[key]; 
					break;
					case 'max': messageErrors[key] = parseInt(formValues[key], 0) > parseInt(param, 0) 
						? `* A quantidade não pode ser acima de ${parseInt(param, 0)}` : messageErrors[key]; 
					break;
					case 'min': messageErrors[key] = parseInt(formValues[key], 0) < parseInt(param, 0) 
						? `* A quantidade não pode ser abaixo de ${parseInt(param, 0)}` : messageErrors[key]; 
					break;
					default: break;
				}
			});
		});

		messageErrors.ads_template_ids = adsTemplates.length !== formValues.ads_template_ids.length
			? '* Falta escolher algum template' : messageErrors.ads_template_ids;

		this.setState({
			messageErrors,
		});

		return Validate.isEmpty(Object.values(messageErrors).join(''));
	};

	getLogoBriefing = () => {
		const { briefing } = this.state;
		const { logo } = briefing;
		if (logo !== '') {
			const extension = logo.substr(logo.lastIndexOf('.') + 1);
			const isImage = file.getImageExtensions().indexOf(extension) !== -1;
				return isImage
					? (<img alt="logo" src={logo} className="img-thumbnail" />)
					: (<div><a target="_blank" rel="noopener noreferrer" href={logo}>Veja o logo aqui.</a></div>);
		}
		return (<p>Sem Logo</p>);
	};

	sendForm = () => {
		const { formValues } = this.state;
		const formIsValid = this.validateForm();

		if (formIsValid) {
			api.post('/campaign_postings', formValues)
			// eslint-disable-next-line no-return-assign
				.then(() => window.location.href = '/backoffice/demandas')
				.catch(e => toaster.danger(e.response.data.errors.map(item => item.message).join('')));
		}
	};

	render() {
		const {
			briefing,
			customer,
			adsTemplates,
			wmAdTypeOptions,
			wmAdOrderOptions,
			wmAdQuantityMin,
			wmAdQuantityMax,
			formValues,
			messageErrors,
		} = this.state;

		const templatesSelect = !adsTemplates
			? (<Alert text="Templates não encontrados." />)
			: adsTemplates.map(channelGroup => (
				<div key={`div_${channelGroup.channel}`} className="form-group col">
					<label className="pull-left">Template {channelGroup.title}</label>
					<select
						key={`select_${channelGroup.channel}`}
						name={channelGroup.channel}
						className="form-control"
						onChange={e => this.handleSelectTemplate(e)}
					>
						{
							this.getTemplateOptions(channelGroup.templates)
								.map(option => (
									<option
										key={`opt_${Str.toSlug(option.label)}`}
										value={option.value}
									>
										{option.label}
									</option>
								))
						}
					</select>
				</div>
			));

		return (
			<Fragment>
				{!briefing ? (<Spinner />) : (
					<div>
						<InfoBar
							data={this.getDataGreyBar()}
						/>
						<Box borderRadius="0px 0px 8px 8px" padding="15px 5px">
							<div className="row">
								<div className="col-7">
									<InfoBar
										data={this.getDataWhiteBar()}
										boxShadow="none"
										itemClassName="col-4"
										backgroundColor="white"
									/>
								</div>
								<div className="col-5 pt-3">
									{this.getLogoBriefing()}
								</div>
							</div>
						</Box>
						<StyledForm>
							<div className="form-group mt-4">
								<label className="label pull-left">ID Google</label>
								<input className="form-control" readOnly value={customer.google_ads_code} />
							</div>
							<div className="form-group">
								<label className="label pull-left">ID Facebook</label>
								<input className="form-control" readOnly value={customer.facebook_ads_code} />
							</div>
							<div className="form-row mt-4">
								{templatesSelect}
							</div>
							<div className="form-row mb-2">
								<small className="pull-left text-danger">
									{messageErrors.ads_template_ids}
								</small>
							</div>
							<div className="form-row">
								<div className="form-group col-3">
									<label className="label pull-left">Ordenação:</label>
									<select
										className="form-control"
										name="wm_ad_order"
										onChange={e => this.handleForm(e)}
									>
										<option value="">Escolher</option>
										{this.renderOptions(wmAdOrderOptions)}
									</select>
									<small className="pull-left text-danger">
										{messageErrors.wm_ad_order}
									</small>
								</div>
								<div className="form-group col-3">
									<label className="label pull-left">Tipo:</label>
									<select
										className="form-control"
										name="wm_ad_type"
										onChange={e => this.handleForm(e)}
									>
										<option value="">Escolher</option>
										{this.renderOptions(wmAdTypeOptions)}
									</select>
									<small className="pull-left text-danger">
										{messageErrors.wm_ad_type}
									</small>
								</div>
								<div className="form-group col-3">
									<label className="label pull-left">Quantidade de anúncios:</label>
									<input
										className="form-control"
										type="number"
										name="wm_ad_quantity"
										max={wmAdQuantityMax}
										min={wmAdQuantityMin}
										onChange={e => this.handleForm(e)}
										value={formValues.wm_ad_quantity}
									/>
									<small className="pull-left text-danger">
										{messageErrors.wm_ad_quantity}
									</small>
								</div>
							</div>
							<button
								type="button"
								className="btn btn-secondary w-100 py-2 mt-5"
								onClick={this.sendForm}
							>
								Publicar campanha
							</button>
						</StyledForm>
					</div>
				)}
			</Fragment>
		);
	}
}
